import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-attachment-view',
  templateUrl: './attachment-view.component.html',
  styleUrl: './attachment-view.component.scss'
})
export class AttachmentViewComponent {

  filePath?: string
  fileUrl = environment.FILE_SERVER_URL;

  private dialogRef: MatDialogRef<AttachmentViewComponent> = inject(MatDialogRef<AttachmentViewComponent>)
  private data: { filePath?: string } = inject(MAT_DIALOG_DATA)

  constructor(
  ) {
    this.filePath = this.data?.filePath
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
